/* Search the full Shopify catalog and show product suggestions in MD search bars. */
(() => {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('form[data-md-search]').forEach(form => {
      const input = form.querySelector('input[name="q"]');
      const panel = form.querySelector('[data-md-suggestions]');
      if (!input || !panel) return;
      input.setAttribute('autocomplete', 'off');
      input.setAttribute('aria-autocomplete', 'list');
      let timer, request, sequence = 0;
      const close = () => {panel.hidden = true; panel.replaceChildren()};
      input.addEventListener('input', () => {
        clearTimeout(timer);
        if (request) request.abort();
        const query = input.value.trim();
        const current = ++sequence;
        if (query.length < 2) {close(); return}
        timer = setTimeout(async () => {
          request = new AbortController();
          try {
            const params = new URLSearchParams({q:query,'resources[type]':'product','resources[limit]':'6','resources[options][unavailable_products]':'last'});
            const response = await fetch('/search/suggest.json?' + params, {signal:request.signal});
            if (!response.ok) throw new Error('Search unavailable');
            const data = await response.json();
            if (current !== sequence) return;
            panel.replaceChildren();
            const products = data.resources?.results?.products || [];
            if (!products.length) {
              const empty = document.createElement('span'); empty.className='md-search-empty'; empty.textContent='No matching products. Press Enter to see all results.'; panel.append(empty);
            }
            products.forEach(product => {
              const link=document.createElement('a'); link.href=product.url; link.className='md-search-result';
              if (product.featured_image?.url) {
                const img=document.createElement('img'); img.src=product.featured_image.url; img.alt=''; img.loading='lazy'; link.append(img);
              }
              const title=document.createElement('span'); title.textContent=product.title; link.append(title);
              panel.append(link);
            });
            panel.hidden=false;
          } catch(error) {if (error.name !== 'AbortError') close()}
        },180);
      });
      form.addEventListener('submit', event => {if (!input.value.trim()) {event.preventDefault();input.focus()} });
      input.addEventListener('keydown', event => {if(event.key==='Escape')close()});
      document.addEventListener('click', event => {if(!form.contains(event.target))close()});
    });
  });
})();
